import { STATUS_LABELS } from "../lib/format";

const STYLES: Record<string, string> = {
  created: "bg-slate-100 text-slate-600 border-slate-200",
  in_progress: "bg-liaise-navy-50 text-liaise-navy border-liaise-navy-200",
  submitted: "bg-orange-50 text-orange-700 border-orange-200",
  evaluated: "bg-green-50 text-green-700 border-green-200",
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded-full border ${STYLES[status] ?? STYLES.created}`}>
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}

export function WritingBadge({ result }: { result: string }) {
  if (result === "satisfied")
    return <span className="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">Satisfied</span>;
  if (result === "dissatisfied")
    return <span className="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-red-50 text-red-700 border border-red-200">Dissatisfied</span>;
  return <span className="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 border border-slate-200">Unevaluated</span>;
}
